import { GET_BRANDS } from '@/api';
import { brandsService } from '@/api/brands';
import { HeaderFilterTable } from '@/components/common';
import { AvatarName } from '@/components/dashboard';
import { Options } from '@/components/ui/combobox';
import { useFilters } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import React from 'react';

const FILTER_KEY = 'brandId';

export const BrandsFilter = () => {
	const [optionsBrands, setOptionsBrands] = React.useState<Options[]>([]);
	const { setParamFilter, hasFilter } = useFilters();
	const { data: brands } = useQuery({
		queryKey: [GET_BRANDS],
		queryFn: () => brandsService.get(),
	});

	const listBrands = brands?.data.items;

	React.useEffect(() => {
		if (listBrands) {
			const parsedBrands: Options[] = [];
			listBrands.forEach((element) => {
				parsedBrands.push({
					value: element.id,
					label: (
						<AvatarName
							isBold
							name={element.name}
							photoUrl={
								element.logo ||
								'https://claimmagic-backend-dev.s3.us-east-1.amazonaws.com/assets/logos/6ac13339-db98-494e-9bf7-f1c0184579f6.png'
							}
							size="small"
							classNameText="max-w-[255px] !truncate"
						/>
					),
				});
			});
			setOptionsBrands(parsedBrands);
		}
	}, [listBrands]);

	const handleSelectFilters = (value?: string) => {
		setParamFilter(FILTER_KEY, value);
	};

	const handleClearAll = () => {
		setParamFilter(FILTER_KEY, '');
	};

	return (
		<div>
			<HeaderFilterTable
				title="Brand"
				searchTitle="Brands"
				filterOptions={optionsBrands}
				handleClearAll={handleClearAll}
				handleSelectFilters={handleSelectFilters}
				classNamePopoverContent="md:!w-[343px]  pb-4"
				classNameCommandItem="!px-2"
				hasFilter={hasFilter(FILTER_KEY)}
				classNameCommandList="!pl-0 !max-h-[315px] overflow-y-scroll"
			/>
		</div>
	);
};
